import {PublicSubmitForm} from '../../sdk/interface/form/public-submit-form';
import {SimpleChanges} from '@angular/core';

export abstract class PrefilledSignupForm<T> extends PublicSubmitForm
{
    abstract patchPrefilledDataToForm(prefilledData: T): void;

    abstract loadPrefilledDetails(changes: SimpleChanges): void;
}